import Cart from "../../../Components/Client/Cart";

const CartPage = () => {
  return <Cart />;
};

export default CartPage;
